import { createContext } from 'react';

import { SeriesCurve } from '../../core/types/timeseries.js';

export const TimeseriesChartSeriesCurve = createContext<
  SeriesCurve | undefined
>(undefined);

TimeseriesChartSeriesCurve['displayName'] = 'TimeseriesChartSeriesCurve';
